const WAITING_PAGE = 'extras_waiting_page';

export const hideWaitingPage = () => {
  const waitingPage = document.getElementById(WAITING_PAGE);
  if (waitingPage) {
    waitingPage.style.display = 'none';
  }
};
